export const ActionTypes = {
    SET_GRAPH_DATA: "app/redux/stations/SET_GRAPH_DATA",
    SET_RENDERING: "app/redux/stations/SET_RENDERING",
    SET_VISIBLE: "app/redux/stations/SET_VISIBLE",
}